import React,{ Component } from 'react';
import Notifications from './Notification';
import ProjectList from '../projects/ProjectList'
import {connect} from 'react-redux'
import { firestoreConnect } from 'react-redux-firebase'
import { compose } from 'redux'
import Cards from '../corosal/cards';
import MyComponent from '../corosal/cor';
import Footer from './footer';
import CardSlide from '../corosal/slidecard';
import MyClub from './about';

class Dashboard extends Component{
    render(){
        //console.log(this.props);
        const { projects } = this.props;
        return(
            <div>
                 <div>
                     <MyComponent />
                     </div>
                     <br/>
                     <div style={{backgroundColor: 'rgb(24,34,78)'}}>
          <h1 class="font_meie_script" style={{ textAlign:'center',color:'white',fontFamily:'italic' }}>About</h1>
                  </div>
                  <br/>
                  <MyClub />
                     <br/>
                     <div style={{backgroundColor: 'rgb(24,34,78)'}}>
          <h1 class="font_meie_script" style={{ textAlign:'center',color:'white',fontFamily:'italic' }}>Events</h1>
                  </div>
                  <br/>
                     <div>
                     <CardSlide />
                 </div>
                 <br/>
                 <div style={{backgroundColor: 'rgb(24,34,78)'}}>
           <h1 class="font_meie_script" style={{ textAlign:'center',color:'white',fontFamily:'italic' }}>News</h1>
                  </div>
               <div className="dashboard container">
                <div className="row">
                    <div className="col s12 m6">
                        <ProjectList projects={projects}/>
                    </div>
                    <div className="col s12 m5 offset-m1"></div>
                    <Notifications />
                     </div>
                </div>
                <Footer />
             </div>
            )
    }
}
const mapStateToProps = (state)=>{
    console.log(state);
    return {
        projects: state.firestore.ordered.projects
    }
}
export default compose(
    connect(mapStateToProps),
    firestoreConnect([
        { collection: 'projects' }
    ])
)(Dashboard)